module.exports = __webpack_public_path__ + "imgs/banner-bg.4b635487b4d180100de900e78fb191ed.jpg";